export default {
    navigationBarTitleText: intl.get('solution.commercialRealEstateSolutions'),
    navigationBarBackgroundColor: "#DF773C",
};
